import React from 'react';
import PropTypes from 'prop-types';
import './LightboxContainerMobile.css';
import { connect } from 'react-redux';
import { backgroundSet } from '../../../redux/helpers/setBackground';

class LightboxContainerMobile extends React.Component {
	constructor(props) {
		super(props);
	}

	closeIcon = () => {
		const { lang, closeLightBox } = this.props;

		return (
			<span className="close"
			onClick={e => closeLightBox(e)}
			onKeyDown={() => {}}
			role="presentation">
				{lang.close}
			</span>
		);
	}

	setImage = () => {
    const {
       pages, lang, selectedBackground
    } = this.props;

		const {
			fullUrl, thumbnailUrl, sizes
		} = selectedBackground;

    backgroundSet(thumbnailUrl, fullUrl, pages, lang, sizes, this.props);
  }

	render() {
		const {
		showImage,
		} = this.props;

		return (
		<div className="lightboxContainerMobile" >
			{ <img src={showImage} alt="" />}
			<button className="select-btn" onClick={this.setImage}>Kiválaszt</button>
			{ this.closeIcon() }
		</div>
		);
	}
}

LightboxContainerMobile.defaultProps = {
  lang: {},
  closeLightBox: () => {},
  showImage: '',
	handleBackgroundOpen: () => {},
	selectedBackground: {},
};
  
LightboxContainerMobile.propTypes = {
  lang: PropTypes.object,
  closeLightBox: PropTypes.func,
  showImage: PropTypes.string,
	handleBackgroundOpen: PropTypes.func,
	selectedBackground: PropTypes.object,
};

export default connect(state => ({
  pages: state.entities.pages.byId,
  isBabyBook: state.bookProperties.isBabyBook,
  coverType: state.bookProperties.cover.type,
  backgroundSelected: state.editorUI.backgroundImageSelected,
  datePlaceholders: state.entities.datePlaceholders,
}))(LightboxContainerMobile);



// WEBPACK FOOTER //
// ./src/components/lightbox/lightbox-container-mobile/LightboxContainerMobile.jsx